import PedidoEnderecoService from "@/services/PedidoEnderecoService";

export const pedidoEndereco = {
  namespaced: true,
  state: {
    pedidoEndereco: {},
  },
  actions: {
    getPedidoEndereco({ commit }, payload) {
      return PedidoEnderecoService.GetPedidoEndereco(payload).then(
        (pedidoEndereco) => {
          return Promise.resolve(pedidoEndereco);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postPedidoEndereco({ commit }, payload) {
      return PedidoEnderecoService.PostPedidoEndereco(payload).then(
        (pedidoEndereco) => {
          return Promise.resolve(pedidoEndereco);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putPedidoEndereco({ commit }, payload) {
      return PedidoEnderecoService.PutPedidoEndereco(payload).then(
        (pedidoEndereco) => {
          return Promise.resolve(pedidoEndereco);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deletePedidoEndereco({ commit }, payload) {
      return PedidoEnderecoService.DeletePedidoEndereco(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getPedidoEnderecoOData({ commit }, payload) {
      return PedidoEnderecoService.GetPedidoEnderecoOData(payload).then(
        (pedidoEndereco) => {
          return Promise.resolve(pedidoEndereco);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default pedidoEndereco;
